export enum SolutionTypeTag {
    Mitigation,
    Investigation,
    Monitoring,
    Prevention
}
